import React from 'react';
import './Section2.css';

const SectionTwo = () => {
  return (
    <section className="section-two">
      <div className="section-two-container">
        {/* Left Text */}
        <div className="section-two-left">
          Our platform empowers vendors and local businesses by combining{' '}
          <span className="section-two-highlight">
            nationwide digital reach and real-world community engagement.
          </span>
        </div>

        {/* Right Features */}
        <div className="section-two-right">
          <div className="feature-box">
            <h3>Marketplace built for Canadian vendors</h3>
            <p>
              Our platform connects local businesses and shoppers across Canada —
              allowing vendors to showcase their products online with zero technical hassle,
              and customers to explore curated, diverse selections under one roof.
            </p>
          </div>

          <div className="feature-box">
            <h3>Bi-weekly pop-ups in Toronto & Montreal</h3>
            <p>
              We host in-person pop-up markets every two weeks in Toronto and Montreal —
              with plans to expand to more provinces. These events drive visibility for our vendors
              and offer shoppers a unique hands-on experience.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionTwo;
